import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RotateCcwIcon, XIcon } from 'lucide-react';
interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  count: number;
  isRestoring: boolean;
}
export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  count,
  isRestoring
}: ConfirmDialogProps) {
  return <AnimatePresence data-id="element-61">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-40" onClick={onClose} data-id="element-62" />

          {/* Dialog */}
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none" data-id="element-63">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 8
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 8
        }} transition={{
          duration: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden pointer-events-auto border border-slate-200" role="dialog" aria-modal="true" aria-labelledby="dialog-title" data-id="element-64">
              <div className="p-5" data-id="element-65">
                <div className="flex items-start justify-between mb-4" data-id="element-66">
                  <div className="w-10 h-10 bg-cyan-50 rounded-full flex items-center justify-center border border-cyan-100" data-id="element-67">
                    <RotateCcwIcon className="w-5 h-5 text-cyan-600" data-id="element-68" />
                  </div>
                  <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors rounded-full p-1 hover:bg-slate-100 -mt-0.5 -mr-0.5" disabled={isRestoring} aria-label="Close dialog" data-id="element-69">
                    <XIcon className="w-4 h-4" data-id="element-70" />
                  </button>
                </div>

                <h2 id="dialog-title" className="text-lg font-semibold text-slate-900 mb-1.5" data-id="element-71">
                  Restore {count} deleted {count === 1 ? 'Case' : 'Cases'}?
                </h2>
                <p className="text-sm text-slate-500 leading-relaxed mb-5" data-id="element-72">
                  {count === 1 ? 'This Case' : 'These Cases'} will be returned
                  from the Recycle Bin and made active again for this
                  Opportunity.
                </p>

                <div className="flex items-center justify-end gap-2.5" data-id="element-73">
                  <button onClick={onClose} disabled={isRestoring} className="px-4 py-2 text-sm font-medium text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-cyan-500/40 disabled:opacity-50 transition-colors" data-id="element-74">
                    Cancel
                  </button>
                  <button onClick={onConfirm} disabled={isRestoring} className="px-4 py-2 text-sm font-medium text-white bg-cyan-600 rounded-lg hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-cyan-500/40 disabled:opacity-70 inline-flex items-center transition-colors shadow-sm shadow-cyan-600/20" data-id="element-75">
                    {isRestoring ? <>
                        <svg className="animate-spin -ml-0.5 mr-2 h-3.5 w-3.5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-76">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-77"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-78"></path>
                        </svg>
                        Restoring…
                      </> : 'Confirm Restore'}
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}